import { findOrError } from "./html.ts";
import { empty } from "./string.ts";

export interface ProblemDetailsDialog {
    show(response: Response): Promise<void>;
}

const statusCodes = new Set<number>();
statusCodes.add(400);

export function setupProblemDetailsDialog(): ProblemDetailsDialog {
    const dialog = findOrError<HTMLDialogElement>('#problem-details-dialog');
    const title = findOrError('.dialog-title', dialog);
    const detailParagraph = findOrError('p', dialog);

    return {
        show
    };

    async function show(response: Response) {
        const details = await getProblemDetails(response);
        if (!details) return;
        title.textContent = details.title ?? '';
        detailParagraph.innerHTML = details.detail ?? '';

        dialog.showModal();
    }
}

export function setupProblemDetailsForm(dialog: HTMLElement) {
    const callout = findOrError<HTMLElement>('.error-callout', dialog);
    const titleLabel = findOrError('.error-title', callout);
    const detailLabel = findOrError('.error-detail', callout);
    const errorList = findOrError('.error-list', callout);
    const form = dialog.querySelector('form');

    return {
        show,
        reset
    };

    async function show(response: Response) {
        const details = await getProblemDetails(response);
        if (!details) return;

        titleLabel.textContent = details.title ?? '';
        detailLabel.textContent = details.detail ?? '';
        errorList.innerHTML = '';
        callout.hidden = false;

        if (details.errors) {
            for (const error of details.errors) {
                const titleItem = document.createElement('li');
                titleItem.textContent = error.title;
                errorList.append(titleItem);
            }
        }
    }

    function reset() {
        titleLabel.textContent = '';
        detailLabel.textContent = '';
        callout.hidden = true;
    }
}

async function getProblemDetails(response: Response) {
    if (response.ok) return;
    if (!statusCodes.has(response.status)) return;
    const details = await response.json() as ProblemDetails;
    if (empty(details.title)) return;
    return details;
}

interface ProblemDetails {
    title?: string;
    detail?: string;
    errors?: Error[];
}

interface Error {
    code: number;
    title: string;
    description: string;
}

